export default "__VITE_ASSET__CjJONBra__"